import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
type ModalType = 'terms' | 'privacy' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-[#0a1118] text-text-muted py-8 border-t border-secondary-dark" data-id="element-38">
        <div className="container mx-auto px-6 text-center" data-id="element-39">
          <p className="text-sm" data-id="element-40">
            &copy; {new Date().getFullYear()} Trabajo Bajo Control. Todos los
            derechos reservados.
          </p>
          <div className="mt-4 flex justify-center gap-4 text-xs opacity-60" data-id="element-41">
            <button onClick={() => setActiveModal('terms')} className="hover:text-accent transition-colors cursor-pointer bg-transparent border-none text-inherit font-inherit text-xs" data-id="element-42">
              Términos y Condiciones
            </button>
            <button onClick={() => setActiveModal('privacy')} className="hover:text-accent transition-colors cursor-pointer bg-transparent border-none text-inherit font-inherit text-xs" data-id="element-43">
              Política de Privacidad
            </button>
          </div>
        </div>
      </footer>

      <AnimatePresence data-id="element-44">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-4" onClick={() => setActiveModal(null)} data-id="element-45">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} className="bg-[#0f1a24] border border-secondary-dark rounded-xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-46">
              <div className="sticky top-0 bg-[#0f1a24] border-b border-secondary-dark px-6 py-4 flex items-center justify-between z-10" data-id="element-47">
                <h2 className="text-lg font-semibold text-text-primary" data-id="element-48">
                  {activeModal === 'terms' ? 'Términos y Condiciones' : 'Política de Privacidad'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="text-text-muted hover:text-text-primary transition-colors p-1 rounded-lg hover:bg-white/5" aria-label="Cerrar" data-id="element-49">
                  <XIcon size={20} data-id="element-50" />
                </button>
              </div>

              <div className="px-6 py-5 text-sm text-text-muted leading-relaxed space-y-4" data-id="element-51">
                {activeModal === 'terms' ? <TermsContent data-id="element-52" /> : <PrivacyContent data-id="element-53" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-text-primary font-medium" data-id="element-54">
        Última actualización: Abril 2026
      </p>

      <h3 className="text-text-primary font-semibold mt-4" data-id="element-55">
        1. Aceptación de los Términos
      </h3>
      <p data-id="element-56">
        Al acceder y utilizar este sitio web y los servicios ofrecidos por
        Trabajo Bajo Control, aceptas cumplir con estos Términos y Condiciones.
        Si no estás de acuerdo con alguno de estos términos, te pedimos que no
        utilices nuestros servicios.
      </p>

      <h3 className="text-text-primary font-semibold mt-4" data-id="element-57">
        2. Descripción del Servicio
      </h3>
      <p data-id="element-58">
        Trabajo Bajo Control ofrece contenido educativo, herramientas y recursos
        diseñados para ayudar a profesionales a mejorar su productividad y
        gestión del trabajo. Los materiales proporcionados son de carácter
        informativo y educativo.
      </p>

      <h3 className="text-text-primary font-semibold mt-4" data-id="element-59">3. Uso Permitido</h3>
      <p data-id="element-60">
        Te comprometes a utilizar nuestros servicios únicamente para fines
        legales y de acuerdo con estos términos. Queda prohibido reproducir,
        distribuir o modificar el contenido sin autorización previa por escrito.
      </p>

      <h3 className="text-text-primary font-semibold mt-4" data-id="element-61">
        4. Propiedad Intelectual
      </h3>
      <p data-id="element-62">
        Todo el contenido, incluyendo textos, gráficos, logotipos, imágenes y
        materiales descargables, es propiedad de Trabajo Bajo Control y está
        protegido por las leyes de propiedad intelectual aplicables.
      </p>

      <h3 className="text-text-primary font-semibold mt-4" data-id="element-63">
        5. Limitación de Responsabilidad
      </h3>
      <p data-id="element-64">
        Los resultados pueden variar según cada persona. Trabajo Bajo Control no
        garantiza resultados específicos derivados del uso de nuestros servicios
        o materiales. El uso de la información proporcionada es bajo tu propia
        responsabilidad.
      </p>

      <h3 className="text-text-primary font-semibold mt-4" data-id="element-65">
        6. Pagos y Reembolsos
      </h3>
      <p data-id="element-66">
        Los pagos realizados por productos o servicios son procesados de forma
        segura. Las políticas de reembolso específicas se detallan en la página
        de cada producto o servicio al momento de la compra.
      </p>

      <h3 className="text-text-primary font-semibold mt-4" data-id="element-67">
        7. Modificaciones
      </h3>
      <p data-id="element-68">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones entrarán en vigor desde su publicación en
        este sitio web. El uso continuado de nuestros servicios constituye la
        aceptación de los términos modificados.
      </p>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-text-primary font-medium" data-id="element-69">
        Última actualización: Abril 2026
      </p>

      <h3 className="text-text-primary font-semibold mt-4" data-id="element-70">
        1. Información que Recopilamos
      </h3>
      <p data-id="element-71">
        Podemos recopilar información personal que nos proporcionas
        voluntariamente, como tu nombre y dirección de correo electrónico al
        suscribirte a nuestra lista, realizar una compra o completar un
        formulario.
      </p>

      <h3 className="text-text-primary font-semibold mt-4" data-id="element-72">
        2. Uso de la Información
      </h3>
      <p data-id="element-73">
        Utilizamos la información recopilada para: enviar contenido y
        actualizaciones relevantes, procesar transacciones, mejorar nuestros
        servicios y personalizar tu experiencia en nuestro sitio.
      </p>

      <h3 className="text-text-primary font-semibold mt-4" data-id="element-74">
        3. Protección de Datos
      </h3>
      <p data-id="element-75">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado,
        alteración, divulgación o destrucción.
      </p>

      <h3 className="text-text-primary font-semibold mt-4" data-id="element-76">
        4. Cookies y Tecnologías de Seguimiento
      </h3>
      <p data-id="element-77">
        Nuestro sitio puede utilizar cookies y tecnologías similares para
        mejorar la experiencia del usuario, analizar el tráfico del sitio y
        personalizar el contenido. Puedes configurar tu navegador para rechazar
        cookies.
      </p>

      <h3 className="text-text-primary font-semibold mt-4" data-id="element-78">
        5. Compartir Información con Terceros
      </h3>
      <p data-id="element-79">
        No vendemos, intercambiamos ni transferimos tu información personal a
        terceros sin tu consentimiento, excepto cuando sea necesario para
        proporcionar nuestros servicios o cuando la ley lo requiera.
      </p>

      <h3 className="text-text-primary font-semibold mt-4" data-id="element-80">6. Tus Derechos</h3>
      <p data-id="element-81">
        Tienes derecho a acceder, rectificar, eliminar o limitar el tratamiento
        de tus datos personales. Para ejercer estos derechos, puedes comunicarte
        con nosotros a través de los canales disponibles.
      </p>

      <h3 className="text-text-primary font-semibold mt-4" data-id="element-82">
        7. Cambios en esta Política
      </h3>
      <p data-id="element-83">
        Nos reservamos el derecho de actualizar esta política de privacidad en
        cualquier momento. Te notificaremos sobre cambios significativos
        publicando la nueva política en este sitio web.
      </p>
    </>;
}